import { supportServiceConnectClient } from "api";

import {
  GetTrainingAppFeaturesRequest,
  GetTrainingAppFeaturesResponse,
  UpdateTrainingAppFeaturesRequest,
} from "@safetyculture/s12-apis-connect-web/s12/training/admin/v1/appfeatures_pb";
import {
  CopyCourseRequest,
  CopyCourseResponse,
  GetCoursesRequest,
  GetCoursesRequest_PublicationStatus,
} from "@safetyculture/s12-apis-connect-web/s12/training/admin/v1/courses_pb";
import { GetCoursesResponse } from "@safetyculture/s12-apis-connect-web/s12/training/courses/v1/responses_pb";

import { RequestMetadata } from "api/types";
import { toUUID } from "helpers/s12-helpers";

type TrainingAppFeaturesParams = {
  organisationID: string;
  features?: { [key: string]: boolean };
};

export type TrainingCoursesParams = {
  organisationID: string;
  page: number;
  pageSize: number;
  publicationStatus?: GetCoursesRequest_PublicationStatus;
  searchQuery?: string;
};

type TrainingCopyCourseParams = {
  fromOrganisationID: string;
  courseID: string;
  toOrganisationID: string;
  toOrganisationRegion: string;
  overwrite: boolean;
};

export const getAppFeatures = async (
  { organisationID }: TrainingAppFeaturesParams,
  headers: Record<RequestMetadata, string>,
): Promise<GetTrainingAppFeaturesResponse> => {
  const req = new GetTrainingAppFeaturesRequest({ orgId: organisationID });
  return supportServiceConnectClient.getTrainingAppFeatures(req, { headers });
};

export const updateAppFeatures = async (
  { organisationID, features }: Required<TrainingAppFeaturesParams>,
  headers: Record<RequestMetadata, string>,
) => {
  const req = new UpdateTrainingAppFeaturesRequest({
    orgId: organisationID,
    features,
  });
  return supportServiceConnectClient.updateTrainingAppFeatures(req, {
    headers,
  });
};

export const getCourses = async (
  {
    organisationID,
    page,
    pageSize,
    publicationStatus,
    searchQuery,
  }: TrainingCoursesParams,
  headers: Record<RequestMetadata, string>,
): Promise<GetCoursesResponse> => {
  const req = new GetCoursesRequest({
    orgId: toUUID(organisationID),
    page,
    pageSize,
    publicationStatus,
    searchQuery,
  });
  return supportServiceConnectClient.getCourses(req, { headers });
};

export const copyCourse = async (
  {
    fromOrganisationID,
    courseID,
    toOrganisationID,
    toOrganisationRegion,
    overwrite,
  }: TrainingCopyCourseParams,
  headers: Record<RequestMetadata, string>,
): Promise<CopyCourseResponse> => {
  const req = new CopyCourseRequest({
    fromOrgId: toUUID(fromOrganisationID),
    courseId: courseID,
    toOrgId: toUUID(toOrganisationID),
    toOrgRegion: toOrganisationRegion,
    overwrite,
  });
  return supportServiceConnectClient.copyCourse(req, { headers });
};
